import * as React from 'react';
import { Font, Palette, ThemeConfiguration } from 'mm-theme-configuration';
import { ThemeManager } from './themeManager';
import { translateFontSizes } from './fontSizeTranslator';

interface ThemeProviderWithFontsProps {
  palette: Palette
  themeConfiguration: ThemeConfiguration
}

export interface FontFamilyPair {
  fontFamily: string
  defaultFontFamily: string
}

interface FontFamilyByElement {
  h1: FontFamilyPair
  h2: FontFamilyPair
  h3: FontFamilyPair
  h4: FontFamilyPair
  span: FontFamilyPair
  p: FontFamilyPair
}

export interface WebFontsComponentProps {
  fontFamilyByElement: FontFamilyByElement
  fontsConfiguration: Font[]
}

const elements = ['h1', 'h2', 'h3', 'h4', 'span', 'p'];

export const ThemeContext: React.Context<{ [key: string]: any }> = React.createContext({});

export const ThemeProviderWithFonts = (WebFontsComponent: React.FunctionComponent<WebFontsComponentProps>) => {
  const ThemeProviderWithFontsComponent: React.FunctionComponent<ThemeProviderWithFontsProps> = props => {
    const { children, palette, themeConfiguration } = props;
    const themeManager = new ThemeManager(palette, themeConfiguration);
    const configuration = themeManager.getConfiguration();
    const fontSizesStyles = translateFontSizes(configuration.fontSizeMap);

    const themeContext = {
      ...configuration,
      fontSizesStyles,
    };
    const fontsConfiguration = themeManager.paletteManager.getFonts();
    const fontFamilyByElement = elements.reduce((acc, element) => ({
      ...acc,
      [element]: {
        fontFamily: themeManager.paletteManager.getFontFamilyByKey(element),
        defaultFontFamily: themeManager.paletteManager.getDefaultFontFamilyByKey(element),
      },
    }), {}) as FontFamilyByElement;

    return (
      <React.Fragment>
        <WebFontsComponent fontFamilyByElement={fontFamilyByElement} fontsConfiguration={fontsConfiguration}>
          <ThemeContext.Provider value={themeContext}>
            {children}
          </ThemeContext.Provider>
        </WebFontsComponent>
      </React.Fragment>
    );
  };
  return ThemeProviderWithFontsComponent;
};
